<template>
  <div class="bto-sb-market-item">
    <span class="bto-sb-market-name"> {{ outcome.enrichedOutcomeName || outcome.name }}</span>
    <span
      v-if="outcome.id > 0"
      v-on:click.prevent="processOdds()"
      v-bind:class="[
        'bto-sb-event-odd',
        {
          'bto-sb-odd-lock':
            outcome.outcome === '--' || outcome.active === false || match.isBetStop || isSuspended,
          'bto-sb-event-odd-active': isOddSelected,
          [updateClasses[`class-${outcome.upDownClass}`]]: true,
          'bto-sb-event-odd-x': outcome.name === xOutcomeName,
        },
        quickBetClasses,
      ]">
      <span
        v-if="getQuickBetNotification && getQuickBetNotification.betslip.status === 4"
        class="bto-sb-spinner-v1"></span>
      <i>{{ formatOddDisplay(outcome.originalDecimalOutcome, $root.oddFormat) }}</i>
    </span>
  </div>
</template>

<script>
  import { toggleItem, toggleAlgoItem, isOddActive, placeQuickBet, getQuickbetPlacementMessage } from '@bto-services/betslip-core';
  import { mapMatchToBetslipItem, mapMatchToBetslipMatchItem, getQuickBetClass } from 'bto-models/betslip';
  import { showBetslipValidation } from '@bto-services/modal';
  import { formatOddDisplay } from '@bto-services/utils';

  export default {
    name: 'MatchOddsDetails',
    props: {
      match: {
        type: Object,
        default: () => { },
      },
      outcome: {
        type: Object,
        default: () => ({ upDownClass: 0 }),
      },
      odd: {
        type: Object,
        default: () => { },
      },
    },
    data() {
      return {
        updateClasses: {
          'class-1': 'bto-sb-odd-up-2',
          'class--1': 'bto-sb-odd-dw-2',
          'class-0': '',
          'class-': '',
        },
        xOutcomeName: 'Draw1',
      };
    },
    computed: {
      isOddSelected() {
        return isOddActive({
          matchId: this.match.matchId,
          outcomeId: this.outcome.id,
          marketId: this.odd.marketId,
        });
      },
      isSuspended() {
        return this.match.suspended || this.outcome.suspended;
      },
      getQuickBetNotification() {
        return getQuickbetPlacementMessage({
          matchId: this.match.matchId,
          outcomeId: this.outcome.id,
          marketId: this.odd.marketId,
        });
      },
      quickBetClasses() {
        return getQuickBetClass(this.getQuickBetNotification);
      },
    },
    methods: {
      processOdds() {
        if (this.outcome.outcome === '--' || this.outcome.active === false || this.match.isBetStop || this.isSuspended) {
          return;
        }
        const betslip_item = mapMatchToBetslipItem(
          this.match,
          this.outcome,
          this.odd,
          false,
          !this.match.isLiveMatch,
          false,
          this.match.isLiveMatch);
        const betslipMatchItem = mapMatchToBetslipMatchItem(this.match, false);
        const error = toggleAlgoItem(betslip_item, betslipMatchItem);
        showBetslipValidation(error);
        if (this.isOddSelected) {
          placeQuickBet(betslip_item);
        }
      },
      formatOddDisplay
    }
  };
</script>
